import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '432px',
      height: '264px',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
      background: '#FFFFFF',
      boxShadow: '0px 4px 4px #00000040',
      outline: `2px dashed #B1B1B1`,
      borderRadius: '4px',
      position: 'absolute',
      zIndex: 10,
    },

    iconContainer: {
      margin: '0 auto',
      paddingTop: '70px',
      order: 0,
      zIndex: 20,
    },

    title: {
      marginTop: '-66px',
      order: 1,
    },

    textContainer: {
      marginBottom: '56px',
      order: 2,
    },

    buttons: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'right',
      margin: '0',
      paddingRight: '16px',
      paddingBottom: '16px',
      order: 3,
    },
  },
  {
    name: 'FileErrorModal',
  },
);
